import { Component } from "react";
import { injectIntl } from "react-intl";

import { intlShape } from "../../shapes";
import { MAX_AMOUNT } from "../../utils/addonUtils";
import { withConfiguration } from "../../context";
import { priceDisplayFormat } from "../../utils/priceUtils";

type OwnProps = {
  planVariantAddon?: {
    id?: string;
    currency?: string;
    name?: string;
    price?: string | number;
    type?: string;
    assets?: number;
    storage?: number;
    disabled?: boolean;
    input_disabled?: boolean;
    quantity_step?: number;
  };
  intl: intlShape;
  amount?: number;
  minAmount?: number;
  maxAmount?: number;
  onChange?: $TSFixMeFunction;
  disabled?: boolean;
  configuration?: {
    planPriceDisplay?: string;
  };
};

type State = $TSFixMe;

const defaultProps: Partial<OwnProps> = {
  maxAmount: MAX_AMOUNT,
};

type Props = OwnProps & typeof defaultProps;

export class PlanVariantAddon extends Component<Props, State> {
  static readonly defaultProps = defaultProps;

  input: $TSFixMe;

  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.onChange = this.onChange.bind(this);
    this.state = { amount: "" };
  }

  componentDidMount() {
    this.setState({ amount: this.props.amount || "0" });
  }

  onChange() {
    const { minAmount, maxAmount } = this.props;
    let amount = null;
    if (this.input.value) {
      amount = parseInt(this.input.value, 10);
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      if (amount > maxAmount) {
        return; // ignore change
      }
      if (minAmount && amount >= minAmount) {
        this.setState({ amount });
        this.dispatchChange(amount);
        return;
      }
      if (!minAmount && amount >= 0) {
        this.setState({ amount });
        this.dispatchChange(amount);
        return;
      }
    }
    if (minAmount) {
      this.setState({ amount: minAmount });
      this.dispatchChange(minAmount);
    } else {
      this.setState({ amount: "" });
      this.dispatchChange(0);
    }
  }

  dispatchChange(amount: $TSFixMe) {
    const { onChange, planVariantAddon } = this.props;
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onChange(amount, planVariantAddon);
  }

  addItem() {
    const { maxAmount } = this.props;
    const currentAmount = parseInt(this.input.value, 10);
    const quantityStep = this.props.planVariantAddon?.quantity_step || 1;
    const amount = currentAmount ? currentAmount + quantityStep : quantityStep;
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    if (amount <= maxAmount) {
      this.setState({ amount });
      this.dispatchChange(amount);
    }
  }

  removeItem() {
    const currentAmount = parseInt(this.input.value, 10);
    const quantityStep = this.props.planVariantAddon?.quantity_step || 1;
    const amount =
      currentAmount && currentAmount > 0 ? currentAmount - quantityStep : 0;
    this.setState({ amount });
    this.dispatchChange(amount);
  }

  render() {
    const {
      planVariantAddon,
      disabled,
      minAmount,
      maxAmount,
      configuration,
      intl,
    } = this.props;
    const quantityInputDisabled = disabled || planVariantAddon?.input_disabled;
    const planVariantAddonPrice = planVariantAddon?.price
      ? String(planVariantAddon?.price)
      : 0;
    const price = planVariantAddonPrice ? parseFloat(planVariantAddonPrice) : 0;
    const { amount } = this.state;
    const planPriceDisplayYearly = configuration?.planPriceDisplay === "yearly";
    const displayPrice = priceDisplayFormat(
      intl,
      price,
      planPriceDisplayYearly,
      planVariantAddon?.currency,
      undefined,
    );

    return (
      <div
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        id={`plan-variant-addon-${planVariantAddon.id}`}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        className={`plan-variant-addon${planVariantAddon.disabled ? " disabled" : ""}`}
      >
        <div className="plan-variant-addon-amount">
          <div className="input-group">
            <span className="input-group-addon">
              <button
                type="button"
                className="remove-button"
                disabled={disabled || amount === minAmount}
                onClick={this.removeItem}
              >
                -
              </button>
            </span>
            <input
              className={`input-control${quantityInputDisabled ? " manual-input-disabled" : ""}`}
              disabled={quantityInputDisabled}
              type="text"
              ref={
                /* istanbul ignore next */ (input) => {
                  this.input = input;
                }
              }
              onChange={this.onChange}
              value={amount}
            />
            <span className="input-group-addon">
              <button
                type="button"
                className="add-button"
                disabled={disabled || amount === maxAmount}
                onClick={this.addItem}
              >
                +
              </button>
            </span>
          </div>
        </div>
        <div className="plan-variant-addon-details">
          <div className="plan-variant-addon-name">
            {planVariantAddon?.name}
          </div>
          <div className="plan-variant-addon-price">({displayPrice})</div>
        </div>
      </div>
    );
  }
}

export default injectIntl(withConfiguration(PlanVariantAddon));
